import { AsyncValidatorFn, FormControl, FormControlOptions, FormControlState, ValidatorFn } from '@angular/forms';
import { Observable, Subject } from 'rxjs';

import { SlFormControlCtor } from '../../models/core/sl-form-control-ctor';
import { SlFormControlInterface } from '../../models/core/sl-form-control-interface';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SlFormControl: SlFormControlCtor = class SlControl<T = any> extends FormControl implements SlFormControlInterface<T> {
    private _onTouchedSub = new Subject<boolean>();

    get onTouched(): Observable<boolean> {
        return this._onTouchedSub;
    }

    constructor(
        formState: FormControlState<T> | T = undefined as T,
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | FormControlOptions | undefined,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | undefined
    ) {
        super(formState, validatorOrOpts, asyncValidator);
    }

    setDisabled(isDisabled: boolean): void {
        if (isDisabled) {
            this.disable();
        } else {
            this.enable();
        }
    }

    override markAsTouched(opts?: { onlySelf?: boolean | undefined } | undefined): void {
        super.markAsTouched(opts);
        this._onTouchedSub.next(true);
    }

    override markAsUntouched(opts?: { onlySelf?: boolean | undefined } | undefined): void {
        super.markAsUntouched(opts);
        this._onTouchedSub.next(false);
    }
};
